import React, { useEffect, useState } from 'react';
import { InfoIcon, TableList, Typography } from 'seagull';
import { useStore, useStoreActions } from "../../../store/store-context";
import { selectors } from "../../../store/state-selectors";
import { MapStatusView } from "../MapStatusView";
import styles from "./MapContactsRow.module.scss";
import QboCustomerDropdown from "../../../components/QboCustomerDropdown/QboCustomerDropdown";
import { FailureReasons } from "./MapContactsModal.utils";
import { OptionType } from "../../../components/QboCustomerDropdown/QboCustomerDropdown.utils";
import { ErrorResponse, ServerError } from "../../../infra/ErrorResponse";
export default function MapContactsRow(props) {
  const {
    anchorContact,
    qboCustomers,
    integratedQboCustomer,
    changeContactLink,
    createNewCustomer,
    testid,
    onInputFocus,
    onInputBlur
  } = props;
  const [mapStatus, setMapStatus] = useState(getContactMapStatus(anchorContact));
  const [failureReason, setFailureReason] = useState(null);
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  const {
    logBI
  } = useStoreActions();
  useEffect(() => {
    setMapStatus(getContactMapStatus(anchorContact));
  }, [anchorContact]);
  const changeMap = async qboCustomerId => {
    setMapStatus('mapping');
    setFailureReason(null);
    try {
      await changeContactLink(anchorContact, qboCustomerId);
    } catch (err) {
      setMapStatus('failedToMap');
      const isDuplicateError = new ErrorResponse(err).status === 409;
      setFailureReason(isDuplicateError ? FailureReasons.DuplicateMapping : FailureReasons.General);
    }
  };
  const createNew = async () => {
    setFailureReason(null);
    setMapStatus('mapping');
    try {
      await createNewCustomer(anchorContact);
    } catch (e) {
      setMapStatus('failedToMap');
      const isDuplicateError = new ErrorResponse(e).hasServerError(ServerError.DuplicateNameExists);
      setFailureReason(isDuplicateError ? FailureReasons.DuplicateNew : FailureReasons.General);
    }
  };
  const onQboCustomerChange = async option => {
    if (!option) {
      logBI(12005, {
        vendorId,
        userId
      });
      changeMap();
      return;
    }
    switch (option.type) {
      case OptionType.Existing:
        {
          logBI(12004, {
            vendorId,
            userId
          });
          changeMap(option.customer.id());
          break;
        }
      case OptionType.CreateNew:
        {
          logBI(12014, {
            vendorId,
            userId
          });
          createNew();
          break;
        }
    }
  };
  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/React.createElement("div", {
        className: styles.anchorContact,
        "data-testid": "anchor-contact"
      }, /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true
      }, "".concat(anchorContact.companyName())), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.anchorContactSecondLine
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        ellipsis: true
      }, "".concat(anchorContact.firstName(), " ").concat(anchorContact.lastName())), anchorContact.email() ? /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        variant: "paragraph2"
      }, "".concat(anchorContact.email())) : null)))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "qbo-contact",
        className: styles.autocompleteWrapper
      }, /*#__PURE__*/React.createElement(QboCustomerDropdown, {
        qboCustomers: qboCustomers,
        value: integratedQboCustomer ? {
          type: OptionType.Existing,
          customer: integratedQboCustomer
        } : null,
        onChange: onQboCustomerChange,
        onInputFocus: onInputFocus,
        onInputBlur: onInputBlur
      }))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        className: styles.status
      }, /*#__PURE__*/React.createElement(MapStatusView, {
        mapStatus: mapStatus
      }), failureReason === FailureReasons.DuplicateMapping && /*#__PURE__*/React.createElement(InfoIcon, {
        "data-testid": "duplicate-contact-map-info",
        info: /*#__PURE__*/React.createElement(React.Fragment, null, "This QBO customer is already synced", /*#__PURE__*/React.createElement("br", null), "with another Anchor contact")
      }), failureReason === FailureReasons.DuplicateNew && /*#__PURE__*/React.createElement(InfoIcon, {
        "data-testid": "duplicate-contact-new-info",
        info: /*#__PURE__*/React.createElement(React.Fragment, null, "Could not create a new client in QuickBooks Online. A client with these details already exists")
      }))
    }]
  });
}
export const getContactMapStatus = contact => contact.integratedId() ? 'mapped' : 'notMapped';